// PayPal
const createPaypalSubscription = (plan, verificationRequest) => {
  const [name, surname] = verificationRequest.name.split(' ');
  return {
    'plan_id': plan,
    'shipping_amount': null,
    'subscriber': {
      'name': {
        'given_name': name,
        'surname': surname !== undefined ? surname : name
      },
      'email_address': verificationRequest.email
    },
    'application_context': {
      'brand_name': 'ArchDaily',
      'shipping_preference': 'NO_SHIPPING',
      'user_action': 'SUBSCRIBE_NOW'
    },
    'custom_id': verificationRequest.id
  };
}

const paypalForSubscriptions = (el, plan, verificationRequest) => {
  let paymentType = 'paypal';
  
  paypal.Buttons({
    enableStandardCardFields: true,  
    style: {
      height: 40
    },
    onClick: function(e){
      e.fundingSource === 'card' ? paymentType = 'card' : paymentType = 'paypal'
    },
    createSubscription: function(data, actions) {
      if (window.ga && ga.loaded)
        ga('send', { hitType: 'event', eventCategory: 'pro-sbs', eventAction: 'start', eventLabel: paymentType });
      const subscriptionData = createPaypalSubscription(plan, verificationRequest);
      return actions.subscription.create(subscriptionData);
    },
    onApprove: function(data, actions) {
      // we show friendly message to tell the user we are working on their order
      const loadingEl = document.querySelector("#paypal-payment-processing");
      loadingEl.style.display = 'block';
      el.style.display = 'none';
      // process subscription and do backend magic
      actions.subscription.get().then((subscription) => {
        if (window.ga && ga.loaded)
          ga('send', { hitType: 'event', eventCategory: 'pro-sbs', eventAction: 'finish', eventLabel: 'paypal'});
        const redirectUrl = `${el.dataset.returnUrl}?id=${subscription.custom_id}&token=${data.billingToken}&subscription_id=${subscription.id}`;
        window.location.replace(redirectUrl);
      });
    }
  }).render(el);
}

export default paypalForSubscriptions;